// removed by extract-text-webpack-plugin
module.exports = {"collapse":"_3PhQDjh2HqwyvVuTf1yYQt","active":"_3aSJh9iYJy2UHx8VsHUR1O","btnCollapse":"_2hJJdmqxWMC8h8Z9KdMCjz","show":"xgHH7PIB_XKMZg6-MCqp5","hide":"_20SIB499_ln09f12jpuGU-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Collapse.scss
// module id = 1115
// module chunks = 0